module.exports = __webpack_public_path__ + "static/media/_F3-ASP_NET__Core.e122b6fc.png";